<h2>{{'invoicesH2' | translate}}</h2>
<button (click)="openSettings()" pButton [label]="'Ustawienia faktur VAT'"></button>
<div class="ui-g" *ngIf="invoices">
    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-4">
        <span class="ui-float-label">
            <p-calendar [style]="{'width':'100%'}" showTime="true" dateFormat="dd.mm.yy" [inputStyle]="{'width':'100%'}" [(ngModel)]="orderFrame.dateFrom">
            </p-calendar>
            <label for="float-input">Data wystawienia od</label>
        </span>
    </div>

    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-4">
        <span class="ui-float-label">
            <p-calendar [style]="{'width':'100%'}" showTime="true" dateFormat="dd.mm.yy" [inputStyle]="{'width':'100%'}" [(ngModel)]="orderFrame.dateTo">
            </p-calendar>
            <label for="float-input">Data wystawienia do</label>
        </span>
    </div>
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-4">
        <button pButton type="button" label="Filtruj" (click)="this.onFilter()"></button>
    </div>

</div>


<p-table [value]="this.invoices" *ngIf="!isLoading && invoices && invoices.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle" style="width:20%">Numer faktury</th>
            <th class="colTitle" style="width:20%">Data wystawienia</th>
            <th class="colTitle" style="width:30%">Użytkownik</th>
            <th class="colTitle" style="width:15%">Numer zamówienia</th>
            <th class="colTitle" style="width:15%">Kwota</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr>
            <td style="width:20%" style="text-decoration: underline;cursor: pointer;"
                (click)="downloadInvoice(invoice)">{{invoice.invoice_number_full}}</td>
            <td style="width:20%">{{invoice?.created_at}}</td>
            <td style="width:30%">{{invoice.user?.user_details?.name}}
                {{invoice.user?.user_details?.surname}}</td>
            <td style="width:15%">{{(invoice.order_id) ? invoice.order_id : 'Doładowanie konta' }}</td>
            <td style="width:15%">
                {{invoice?.total_amount | currencyReduce: true: ((invoice.order) ? invoice.order?.currency_histories?.exchange_rate : 1) | currency: ((invoice.order) ? invoice.order?.currency_histories?.currency_code : "PLN") }}
            </td>
        </tr>
    </ng-template>
</p-table>
<div *ngIf="!isLoading && invoices.length == 0" style="display: flex;justify-content: center;">Brak faktur</div>
<app-loader *ngIf="isLoading"></app-loader>
<div style="height: 30px;"></div>
<p-paginator (onPageChange)="this.onPaginate($event)" *ngIf="invoices.length > 0" [rows]="data.per_page"
    [totalRecords]="data.total"></p-paginator>

    <p-dialog [style]="{width: '500px'}" *ngIf="invoices" [modal]="true" [header]="'Ustawienia faktur VAT'" [(visible)]="isOpenSetting">
        <div class="inv">
            <label>Następny numer faktury</label>
            <input placeholder="Następny numer faktury" [(ngModel)]="settingInvoice.next_number" pInputText>
        </div>

        <div class="inv">
            <label>Szablon numeru faktury</label>
            <input placeholder="Szablon numeru faktury" [(ngModel)]="settingInvoice.template" pInputText>
        </div>

        <div class="inv">
            <p-checkbox [label]="'Generowanie faktur VAT włączone'" [binary]="true" [(ngModel)]="settingInvoice.is_active_generate"></p-checkbox>
        </div>

        <div class="inv">
            <button pButton [label]="'Zapisz'" (click)="onEditSettings()"></button>
        </div>

    </p-dialog>
